import React, { Component } from 'react';
import EmailInput from './EmailTBox';
import { Grid, Button, Typography } from '@material-ui/core';
import { ResetPasswordProps } from '../connected/ResetPasswordCnn';

type State = {
    email: string,
    emailFormatError: boolean
}
class ResetPassword extends Component<ResetPasswordProps, State> {
    constructor(props: ResetPasswordProps) {
        super(props)

        this.state = {
            email: "",
            emailFormatError: false
        }
    }
    render() {
        return (
            <Grid container>
                <Grid item sm={4}></Grid>
                <Grid item sm={4}>
                    {(this.props.passwordResetSuccess === null || this.props.passwordResetSuccess === false) &&
                        <EmailInput email={this.state.email} onFormatErrorChange={(val: boolean) => this.setState({ emailFormatError: val })} onChange={(val: string) => this.setState({ email: val })} />
                    }
                </Grid>
                <Grid item sm={4}></Grid>

                {this.props.resetPasswordMessage &&
                    <Grid item sm={12} style={{ padding: '15px' }}>
                        <Typography variant="h3">{this.props.resetPasswordMessage}</Typography>
                    </Grid>
                }

                <Grid item sm={4}></Grid>
                <Grid item sm={4}>
                    {this.props.passwordResetSuccess === null || this.props.passwordResetSuccess === false ?
                        <Button
                            style={{ width: '100%' }}
                            variant="contained"
                            color="primary"
                            disabled={this.state.emailFormatError || this.state.email === ""}
                            onClick={(e) => this.props.resetPassword(this.state.email)}>Reset password</Button>
                        :
                        <Button
                            style={{ width: '100%' }}
                            variant="contained"
                            color="primary"
                            onClick={(e) => this.props.history.push("/")}>Go back</Button>
                    }
                </Grid>
                <Grid item sm={4}></Grid>
            </Grid>
        );
    }
}

export default ResetPassword;